// extracted by mini-css-extract-plugin
export var modalFooter = "_lk-0";